import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ConfirmComponent } from './components/modais/confirm/confirm.component';
import { AlertComponent } from './components/modais/alert/alert.component';
import { AlertPushComponent } from './components/modais/alert-push/alert-push.component';
import { PromptComponent } from './components/modais/prompt/prompt.component';
import { NgbModule, NgbDropdownModule, NgbCarouselModule, NgbTooltipModule, NgbPaginationModule, NgbAccordionModule, NgbAccordionDirective } from '@ng-bootstrap/ng-bootstrap';
import { CollapseComponent } from './components/collapse/collapse.component';
import { DropzoneDirective } from './diretivas/dropzone.directive';
import { DropzoneComponent } from './components/dropzone/dropzone.component';
import { httpInterceptorProviders } from '../http-interceptors';
import { ModalPageComponent } from './components/modal-page/modal-page.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { LoadingComponent } from './components/loading/loading.component';
import { FilterCondominioPipe } from './pipes/filter-condominio.pipe';
import { TableComponent } from './components/table/table.component';
import { TableDirective } from './components/table/table.directive';
import { FilterTablePipe } from './components/table/filter-table.pipe';
import { NgxPrintModule } from 'ngx-print';
import { ConfirmTrasnferPreCadastroComponent } from './components/modais/confirm-trasnfer-pre-cadastro/confirm-trasnfer-pre-cadastro.component';
import { NgChartsModule } from 'ng2-charts';
import { ResponderSuportesComponent } from './components/modais/responder-suportes/responder-suportes.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { IconsModule } from '../feather-icons/icons.module';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { ImpressaoComponent } from './components/modais/impressao/impressao.component';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from "ngx-spinner";
import { ExibirArquivosComponent } from './components/modais/exibir-arquivos/exibir-arquivos.component';
import { FileSaverModule } from 'ngx-filesaver';
import { LucideAngularModule, icons } from 'lucide-angular';
import { IConfig, NgxMaskDirective, provideEnvironmentNgxMask, NgxMaskPipe } from 'ngx-mask'
import { AtualizacoesDoSistemaComponent } from './components/modais/atualizacoes-do-sistema/atualizacoes-do-sistema.component';

const maskConfigFunction: () => Partial<IConfig> = () => {
  return {
    validation: false,
  };
};


const maskConfig: Partial<IConfig> = {
  validation: false,
};

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    ConfirmComponent,
    AlertComponent,
    AlertPushComponent,
    PromptComponent,
    CollapseComponent,
    DropzoneDirective,
    TableDirective,
    DropzoneComponent,
    ModalPageComponent,
    AccordionComponent,
    LoadingComponent,
    FilterCondominioPipe,
    FilterTablePipe,
    TableComponent,
    ConfirmTrasnferPreCadastroComponent,
    ResponderSuportesComponent,
    ImpressaoComponent,
    ExibirArquivosComponent,
    AtualizacoesDoSistemaComponent
  ],
  providers: [
    httpInterceptorProviders,
    provideEnvironmentNgxMask(maskConfigFunction),
  ],
  imports: [
    NgxMaskDirective,
    NgxMaskPipe,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgbDropdownModule,
    NgbCarouselModule,
    NgbTooltipModule,
    NgChartsModule,
    RouterModule,
    NgbPaginationModule,
    NgxPrintModule,
    NgbAccordionModule,
    CKEditorModule,
    IconsModule,
    LottieModule.forRoot({ player: playerFactory }),
    ToastrModule.forRoot(),
    NgxSpinnerModule,
    // FileSaverModule,
    LucideAngularModule.pick(icons),
  ],
  exports: [
    NgxMaskDirective,
    NgxMaskPipe,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgbDropdownModule,
    CollapseComponent,
    AccordionComponent,
    DropzoneComponent,
    DropzoneDirective,
    NgbCarouselModule,
    ConfirmComponent,
    AlertComponent,
    AlertPushComponent,
    PromptComponent,
    CollapseComponent,
    DropzoneComponent,
    ModalPageComponent,
    NgbTooltipModule,
    NgChartsModule,
    NgbPaginationModule,
    FilterCondominioPipe,
    TableComponent,
    NgxPrintModule,
    NgbAccordionModule,
    NgbAccordionDirective,
    ConfirmTrasnferPreCadastroComponent,
    LoadingComponent,
    CKEditorModule,
    IconsModule,
    LottieModule,
    ToastrModule,
    NgxSpinnerModule,
    // FileSaverModule,
    LucideAngularModule,
  ]
})
export class SharedModule { }
